import { log } from '@/utils/logger';

/**
 * @todo check for refactoring
 */
const removeAccents = (string: string) => {
  const accents = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;';
  const accentsLess = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------';
  const accentsRegexp = new RegExp(accents.split('').join('|'), 'g');

  const withouAccent = string.replace(accentsRegexp, c => accentsLess.charAt(accents.indexOf(c)));

  return withouAccent;
};

export function slugify(string: string): string {
  if (!string) return '';

  if (typeof string !== 'string') {
    log.error('Expected a string');
    return '';
  }

  const lowerCaseString = string.toLowerCase();

  const withDashes = lowerCaseString.replace(/\s+/g, '-');

  const withoutAccents = removeAccents(withDashes);

  const clearedSlug = withoutAccents
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text

  return clearedSlug;
}
